/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ qty: NonNullable<unknown>, unit: NonNullable<unknown> }} Lot_Debt_Fill_OverInputs */

const vi_lot_debt_fill_over = /** @type {(inputs: Lot_Debt_Fill_OverInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bù nhiều hơn số lô nhập ${i?.qty} ${i?.unit} — giảm bớt trước khi lưu.`)
};

/**

* @param {Lot_Debt_Fill_OverInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_debt_fill_over = /** @type {((inputs: Lot_Debt_Fill_OverInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Debt_Fill_OverInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_debt_fill_over(inputs)
});